"use client";

import React from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import useMediaQuery from "@/hooks/useMediaQuery";
import { ISingleColumnRichText } from "@/types";

import "./singleColumnRichText.css";

function SingleColumnRichText(props: ISingleColumnRichText) {
  const { description, title, cta } = props.entry;
  const isMobile = useMediaQuery("(max-width: 600px)");

  if (!description.html) return null;
  return (
    <div className="mb-[30px]">
      {title && (
        <h2
          className={`
                    font-primary
                    text-center
                    text-l
                    md:text-xl
                    font-medium	
                   ${isMobile ? "mt-[40px]" : "mt-[120px]"} 
                    mb-[40px]
                `}
        >
          {title}
        </h2>
      )}
      <section
        className={`
               ${isMobile ? "pb-[40px]" : "py-[40px]"}
                w-full
                px-[16px]
                mx-auto 
                md:w-[662px] 
                font-secondary
                text-m
                rich-text-block
            `}
        dangerouslySetInnerHTML={{ __html: description.html }}
      />
      {cta && (
        <div>
          {cta.map((key, idx) => {
            return (
              <Button
                key={idx}
                size={ButtonSize.LARGE}
                theme={ButtonTheme.WHITE}
                variant={ButtonVariant.PRIMARY}
                customClass={`
                      mx-auto
                      block
                      mt-[24px]
                  `}
              >
                {key?.value}
              </Button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default SingleColumnRichText;
